import { apiFetch } from './client';
import type { Pratica } from '@/types';

export function getPratiche(): Promise<Pratica[]> {
  return apiFetch<Pratica[]>('/espo/pratiche');
}

export function getPratica(id: string): Promise<Pratica> {
  return apiFetch<Pratica>(`/espo/pratiche/${encodeURIComponent(id)}`);
}
